import {ClassComponent, Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import withAttr from 'flarum/common/utils/withAttr';
import Album from '../models/Album';

const translationPrefix = 'kilowhat-cimaise.forum.edit-album.';

interface EditAlbumAttrs {
    album?: Album
    onsave?: (album: Album) => void
    // TODO: ondelete not actually implemented
    ondelete?: () => void
}

export default class EditAlbum implements ClassComponent<EditAlbumAttrs> {
    dirty: boolean = false
    processing: boolean = false

    title: string = ''
    description: string = ''
    isCommunity: boolean = false

    oninit(vnode: Vnode<EditAlbumAttrs>) {
        const {album} = vnode.attrs;

        if (album) {
            this.title = album.title();
            this.description = album.description();
            // Don't retrieve isCommunity value since we don't include it during edit
        }
    }

    view(vnode: Vnode<EditAlbumAttrs>) {
        return m('form', {
            onsubmit: (event: Event) => {
                event.preventDefault();
                this.saveRecord(vnode);
            },
        }, [
            m('.Form-group', [
                m('label', app.translator.trans(translationPrefix + 'title')),
                m('input.FormControl', {
                    value: this.title,
                    oninput: withAttr('value', (value: string) => {
                        this.title = value;
                        this.dirty = true;
                    }),
                }),
            ]),
            m('.Form-group', [
                m('label', app.translator.trans(translationPrefix + 'description')),
                m('textarea.FormControl', {
                    value: this.description,
                    oninput: withAttr('value', (value: string) => {
                        this.description = value;
                        this.dirty = true;
                    }),
                }),
            ]),
            // If the user can create either kind of albums, show setting
            // If that's not the case it'll just be invisible and the user won't know which type is used, which is by design
            !vnode.attrs.album && app.forum.cimaiseCanCreatePersonalAlbums() && app.forum.cimaiseCanCreateCommunityAlbums() ? m('.Form-group', [
                Switch.component({
                    state: this.isCommunity,
                    onchange: (value: boolean) => {
                        this.isCommunity = value;
                        this.dirty = true;
                    },
                }, app.translator.trans(translationPrefix + 'isCommunity')),
            ]) : null,
            m('.ButtonGroup', [
                Button.component({
                    type: 'submit',
                    className: 'Button Button--primary',
                    loading: this.processing,
                    disabled: !this.readyToSave(),
                }, app.translator.trans(translationPrefix + (vnode.attrs.album ? 'save' : 'create'))),
            ]),
        ]);
    }

    readyToSave() {
        if (!this.title) {
            return false;
        }

        return this.dirty;
    }

    data(vnode: Vnode<EditAlbumAttrs>) {
        const data: any = {
            title: this.title,
            description: this.description,
        };

        if (!vnode.attrs.album) {
            data.isCommunity = this.isCommunity;
        }

        return data;
    }

    saveRecord(vnode: Vnode<EditAlbumAttrs>) {
        this.processing = true;

        (vnode.attrs.album || app.store.createRecord<Album>('cimaise-albums')).save(this.data(vnode)).then(album => {
            if (vnode.attrs.onsave) {
                vnode.attrs.onsave(album);
            }

            this.processing = false;
            this.dirty = false;
            m.redraw();
        }).catch(err => {
            this.processing = false;
            m.redraw();
            throw err;
        });
    }
}
